import React, { useContext, useEffect, useState} from 'react';
import {IProps} from './types';
import * as S from './styles';
import { Context } from '@routes/private/Editor/Context';
import Tooltip from '@components/Tooltip';
import AddArtboardIcon from '@assets/icons/addArtboardIcon';
import CreateNew from '@routes/private/Studio/components/CreateNew';
import { IArtboardAttributes, ICommonAttributes, IElement } from '@routes/private/Editor/types';
import { centerStage, refreshStage, getPosNewArtboard } from '@utils/editor';
//import { centerStage, refreshStage } from '@utils/editor';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
const uuid = require('react-uuid');

const AddArtboard: React.FC<IProps> = (props) => {
  let context = useContext(Context);
  const { onZoomChange, editorStatus, onDraggingChange } = useContext(Context);
  const stageRef = context.stageRef;
  const [addArtboard, setAddArtboard]= useState(false);  
  const [creatingArtboard, setCreatingArtboard]= useState(false);  
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const handleAddArtboard=()=>{
    setAddArtboard(!addArtboard);
  }
/*
  const getHeightSpace = (artboard:IElement, childs:IElement[]): number[] =>
  {
    let artboardAttributes=  (artboard.attributes) as ICommonAttributes
    let heights:number[]=[]
    childs.map((child: IElement) => {
      let childAttributes=  (child.attributes) as ICommonAttributes
      if (artboard.id!= child.id){
        if (childAttributes.y > (artboardAttributes.y + artboardAttributes.height))            
          heights.push(childAttributes.y - (artboardAttributes.y + artboardAttributes.height))
        else if (artboardAttributes.y > (childAttributes.y + childAttributes.height))
          heights.push(artboardAttributes.y - (childAttributes.y+ childAttributes.height))    
      }
    })
    return heights;
  }

  const getPosNewArtboard=()=>{

    let posX:any=null;
    let posY:any=null;

    let artboard: any = undefined;
    let heightSpaces: number[] = [];
    //Find to lowest position
    if (context.data[0]?.children && context.data[0]?.children.length > 0)
    {        
        context.data[0].children.map((child: IElement) => {

          let childAttributes=  (child.attributes) as ICommonAttributes
          if (posX==null && posY == null)
          {
            posX = childAttributes.x;
            posY = childAttributes.y + childAttributes.height;
          }
          else
          {
            if (childAttributes.x< posX)
              posX = childAttributes.x;
            if ((childAttributes.y + childAttributes.height )> posY)
              posY = childAttributes.y + childAttributes.height;
          }   
          
          heightSpaces = [...heightSpaces,...getHeightSpace(child,context.data[0].children!)];        
        });
    }
    let defaultSpace = 50;
    if (dsConfig)
        defaultSpace = dsConfig.editorConfig.defaultArtboardSpace??50;
    
    if (heightSpaces.length>0)
      defaultSpace = Math.min(...heightSpaces)
    return {coorX:posX, coorY:posY + defaultSpace};
  }*/


  const createArtboard=(format:any)=>{    
    let pos = getPosNewArtboard(context.data[0].children!,dsConfig);
    //let pos = getPosNewArtboard();
    let width = format.width;
    let height = format.height;
    let name = `${width}x${height}`

    let newAttributes: IArtboardAttributes    
    newAttributes = {
      x: pos.coorX,
      y: pos.coorY,
      width: width,
      height: height,
      hidden: false,         
      backgroundColor:"#ffffff",
      opacity:1,
      clipping:false,
      blendMode:"normal"
    };
    const newArtboardElement: IElement = {
      id: uuid(),
      name: name,
      type: "Artboard",
      attributes: newAttributes
    };    
    context.onCommandChange("addElement", undefined, [context.data[0].id], [newArtboardElement]);        
    setCreatingArtboard(true)
    setAddArtboard(false);
    
  }

  useEffect(() => {
    if (creatingArtboard)
    {        
        setTimeout(() => {  
          if (stageRef.current &&  context.data[0]?.children)
             refreshStage(stageRef.current, context.data[0].children, context.editorStatus.showSelectDescribe, onZoomChange);
        }, 500);      
       setCreatingArtboard(false)         
    }
  }, [context.data[0]?.children && context.data[0]?.children.length])
  

  return (
    <>
    {
      context.editorStatus.editMode && !context.editorStatus.showSelectDescribe &&
      <S.Root onClick={handleAddArtboard}>      
        <Tooltip tip={"Add New Artboard"} boxStyle={{width:"120px", marginLeft:"-20px"}}
          >
            <AddArtboardIcon fillColor={addArtboard ? "white" :"#818181"}/>
        </Tooltip>            
      </S.Root>
    }
    {
        addArtboard && 
        <CreateNew position='right' addArtboard={addArtboard} setAddArtboard={(add:boolean)=> setAddArtboard(add)} createArtboard={createArtboard}></CreateNew>
      }
    
    </>
        
  );
}
  
export default AddArtboard;

